import { BlendMode } from '@website-builder/model/style/blend-mode';
import { SideTitle } from '@website-builder/model/structure/section/side-title';

export class SectionStyle {
  background = '';
  maxWidth = 'uk-container-expand';
  removeHorizontalPadding = '';
  height = '';
  verticalAlign = '';
  expandWidth = '';
  verticalPadding = 'uk-padding-remove-vertical';
  removeTopPadding = '';
  removeBottomPadding = '';
  imageSize = 'uk-background-cover';
  imagePosition = 'uk-background-center-center';
  imageEffect = '';
  imageParallaxValues = [0, 0, 0, 0];
  imageBreakpoint = '';
  visibility = '';
  blendMode: BlendMode;
  sideTitle = new SideTitle();

  static normalize(styles: Partial<SectionStyle>): SectionStyle {
    const pureStyles = new SectionStyle();

    pureStyles.background = styles.background ?? pureStyles.background;
    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.removeHorizontalPadding = styles.removeHorizontalPadding ?? pureStyles.removeHorizontalPadding;
    pureStyles.height = styles.height ?? pureStyles.height;
    pureStyles.verticalAlign = styles.verticalAlign ?? pureStyles.verticalAlign;
    pureStyles.expandWidth = styles.expandWidth ?? pureStyles.expandWidth;
    pureStyles.verticalPadding = styles.verticalPadding ?? pureStyles.verticalPadding;
    pureStyles.removeTopPadding = styles.removeTopPadding ?? pureStyles.removeTopPadding;
    pureStyles.removeBottomPadding = styles.removeBottomPadding ?? pureStyles.removeBottomPadding;
    pureStyles.imageSize = styles.imageSize ?? pureStyles.imageSize;
    pureStyles.imagePosition = styles.imagePosition ?? pureStyles.imagePosition;
    pureStyles.imageEffect = styles.imageEffect ?? pureStyles.imageEffect;
    pureStyles.imageParallaxValues = styles.imageParallaxValues ?? pureStyles.imageParallaxValues;
    pureStyles.imageBreakpoint = styles.imageBreakpoint ?? pureStyles.imageBreakpoint;
    pureStyles.visibility = styles.visibility ?? pureStyles.visibility;
    pureStyles.blendMode = styles.blendMode ?? pureStyles.blendMode;
    pureStyles.sideTitle = styles.sideTitle ?? pureStyles.sideTitle;

    return pureStyles;
  }
}
